import axios from "axios";
import _ from "lodash";
import {
  BlobServiceClient,
  StorageSharedKeyCredential,
} from "@azure/storage-blob";
import { globalWorkflowConfig } from "../views/admin/initiateCall/dataset";

//Microservice Arch--->

const microserviceURLMapping = {
  TEST: {
    AUTH: "http://localhost:4007/v1/",
    ADMIN: "http://localhost:4003/v1/",
    USER: "",
    OTP: "",
    FILE: "https://chatbotomkaraonline2.southindia.cloudapp.azure.com/NICL/v1/",
    FILEPROCESS: "http://localhost:4011/NICL/v1/",
    MESSAGING: "",
    ANALYTICS:
      "https://chatbotomkaraonline2.southindia.cloudapp.azure.com/NICL/v1/",
    GENERAL:
      "https://chatbotomkaraonline2.southindia.cloudapp.azure.com/NICL/v1/",
    OZONTELAPI: "https://cpaas-go.ozonetel.com/Queue",
    GLOBALCONFIG:
      "https://chatbotomkaraonline2.southindia.cloudapp.azure.com/NICL/v1/",
  },
  DEV: {
    AUTH: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    // AUTH: "http://localhost:4007/v1/",
    ADMIN: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    USER: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    OTP: "https://zet.quarkgen.ai/ICCS/zet/v1/otp/",
    FILE: "https://policyexchange.quarkgen.ai/plivo/pe/v1/",
    // FILE: "http://localhost:4040/ICCS/zet/v1/",
    FILEPROCESS: "https://policyexchange.quarkgen.ai/plivo/pe/v1/",
    MESSAGING: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    ANALYTICS: "https://voice.quarkgen.ai/ICCS/tekinfo/v1/",
    // ANALYTICS: "http://localhost:4021/ICCS/zet/v1/",
    GENERAL: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    OZONTELAPI: "https://cpaas-go.ozonetel.com/Queue",
    GLOBALCONFIG: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    STOPCALL: "https://zet.quarkgen.ai/v1/callcontrol/stopcall",
    FILESTATUS: "https://zet.quarkgen.ai/v1/callcontrol/callstatus",
  },
  PROD: {
    AUTH: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    ADMIN: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    USER: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    OTP: "https://zet.quarkgen.ai/ICCS/zet/v1/otp/",
    FILE: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    FILEPROCESS: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    MESSAGING: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    ANALYTICS: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    GENERAL: "https://zet.quarkgen.ai/ICCS/zet/v1/",
    OZONTELAPI: "https://cpaas-go.ozonetel.com/Queue",
    GLOBALCONFIG: "https://zet.quarkgen.ai/ICCS/zet/v1/",
  },
};

const URLMAP = microserviceURLMapping.DEV; // values TEST || DEV || PROD
// const URLMAP = microserviceURLMapping.DEV;

//Call recordings connection
const BLOBSTORAGEURL = "https://teckinfostoragejiowest.blob.core.windows.net/";
const BLOBCONTAINER = "teckinfo-call-recordings";
const FILE = "omkara_info/IVRcd3a7bdb1468a24d1c50e7aeed72cb8b.mp3";
const SASTOKEN =
  "sp=rawli&st=2025-11-14T12:31:56Z&se=2026-11-30T20:46:56Z&spr=https&sv=2024-11-04&sr=c&sig=b0F6lcnqOqOIxQRgfV5ZBnlOKLllxGT5l39qM9mte4g%3D";
//Customer excelfile storage configs
const CSVSTORAGEACCOUNT = "sachatbotdev01";
const CSVBLOBCONTAINER = "nicl-automated-user-list";
const CSVSTOREAGESASTOKEN =
  "sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-12-31T13:16:49Z&st=2024-11-13T05:16:49Z&spr=https&sig=zJPDl3%2BcIbcrWA%2BfWUIs%2BXHWvvNDnbYubaQEOBzaFe0%3D";

export const getAnalyticsApiData = (payload) => {
  // console.log("In this api", payload);
  var params = {
    startDate: payload.selectedDateRange.startDate,
    endDate: payload.selectedDateRange.endDate,
    scenarioID: payload.scenarioID,
    page: payload.page,
    limit: payload.limit,
  };
  // productName=${payload.productName}&agentName=${payload.agentName}&sendSms=${payload.sendSms}

  if (payload.isfilter) {
    params.isfilter = payload.isfilter;
  }
  if (payload.phoneNumber) {
    params.phoneNumber = payload.phoneNumber;
  }
  if (payload.sessionId) {
    params.sessionId = payload.sessionId;
  }
  if (payload.customerName) {
    params.customerName = payload.customerName;
  }
  if (payload.productName) {
    params.productName = payload.productName;
  }
  if (payload.agentName) {
    params.agentName = payload.agentName;
  }
  if (payload.sendSms) {
    params.sendSms = payload.sendSms;
  }
  if (payload.customerQueries) {
    params.customerQueries = payload.customerQueries;
  }
  if (payload.l1SubQuery) {
    params.l1SubQuery = payload.l1SubQuery;
  }
  if (payload.l2SubQuery) {
    params.l2SubQuery = payload.l2SubQuery;
  }
  if (payload.l3SubQuery) {
    params.l3SubQuery = payload.l3SubQuery;
  }

  if (payload.callDuration) {
    params.callDuration = payload.callDuration;
  } else {
    params.callDuration = "default-1";
  }
  return axios.get(
    `${URLMAP.ANALYTICS}analytics`,
    // `${URLMAP.ANALYTICS}analytics?startDate=${payload.selectedDateRange.startDate}&endDate=${payload.selectedDateRange.endDate}&scenarioID=${payload.scenarioID}&page=${payload.page}&limit=${payload.limit}&isfilter=${payload.isfilter}&phoneNumber=${payload.phoneNumber}&customerName=${payload.customerName}&productName=${payload.productName}&agentName=${payload.agentName}&sendSms=${payload.sendSms}`,
    {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const getAnalyticsCallBreakDownApi = (payload) => {
  console.log("call break down api=====", payload);
  return axios.get(
    `${URLMAP.ANALYTICS}analytics/dashboard/callDetails?startDate=${payload.selectedDateRange.startDate}&endDate=${payload.selectedDateRange.endDate}&scenarioID=${payload.scenarioID}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const getAnalyticsCallOverviewApi = (payload) => {
  console.log("call getAnalyticsCallOverviewApi api=====", payload);
  return axios.get(
    `${URLMAP.ANALYTICS}analytics/dashboard/callOverview?startDate=${payload.selectedDateRange.startDate}&endDate=${payload.selectedDateRange.endDate}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const getAnalyticsCallUnansweredApi = (payload) => {
  console.log("call unanswered api=====", payload);
  var params = {
    startDate: payload.selectedDateRange.startDate,
    endDate: payload.selectedDateRange.endDate,
    scenarioID: payload.scenarioID,
    page: payload.page,
    limit: payload.limit,
  };
  // productName=${payload.productName}&agentName=${payload.agentName}&sendSms=${payload.sendSms}

  if (payload.isfilter) {
    params.isfilter = payload.isfilter;
  }
  if (payload.phoneNumber) {
    params.phoneNumber = payload.phoneNumber;
  }

  if (payload.sessionId) {
    params.sessionId = payload.sessionId;
  }

  return axios.get(`${URLMAP.ANALYTICS}analytics/table/unansweredCalls`, {
    params: params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};
export const editAnalyticsDataApi = (payload) => {
  let data = JSON.stringify(payload);
  return axios.put(`${URLMAP.ANALYTICS}analytics/${payload.sessionId}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getTanscriptsApiData = (payload) => {
  return axios.get(
    `${URLMAP.ANALYTICS}analytics?startDate=${payload.selectedDateRange.startDate}&endDate=${payload.selectedDateRange.endDate}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const getAnalyticsCallBreakDownApiINC = (payload) => {
  return axios.get(
    `${URLMAP.ANALYTICS}analytics/dashboard/callDetails?startDate=${payload.selectedDateRange.startDate}&endDate=${payload.selectedDateRange.endDate}`
  );
};

export const editTranscriptDataApi = (payload) => {
  console.log("Edit transcript payload", payload);
  let data = JSON.stringify(payload.data);
  return axios.put(
    `${URLMAP.ANALYTICS}analytics/${payload.data.sessionId}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const loginRequestForUser = (payload) => {
  return axios.post(`${URLMAP.AUTH}login`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getLoggingInUserInfo = (payload) => {
  console.log("payload receined in login method", payload);
  return axios.get(`${URLMAP.ADMIN}admin/me`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const getUserDetails = (payload) => {
  return axios.get(`${URLMAP.ADMIN}admin/${payload.emailId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const getBlobStorageDetails = (payload) => {
  let csvStorageDetails = {
    data: {
      sastoken: CSVSTOREAGESASTOKEN,
      containerName: CSVBLOBCONTAINER,
      storageAccountName: CSVSTORAGEACCOUNT,
    },
  };
  return csvStorageDetails;
  // return axios.get(`${URLMAP.AUTH}blobStorageDetails`, {
  //   headers: {
  //     "Content-Type" : "application/json",
  //   },
  // });
};

export const uploadFileToBlob = async (payload) => {
  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${payload.blobDetails.storageAccountName}.blob.core.windows.net/?${payload.blobDetails.sastoken}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(
    payload.blobDetails.containerName
  );
  const blockBlobClient = containerClient.getBlockBlobClient(
    payload.fileDetails.fileUpdatedName
  );
  let res = await blockBlobClient.upload(payload.csvFile, payload.csvFile.size);
  return res;
};

export const sendOtpToUser = async (payload) => {
  return axios.post(`${URLMAP.OTP}send`, payload.data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const verifyOtpWithUser = async (payload) => {
  return axios.post(`${URLMAP.OTP}verify`, payload.data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const getFilesData = async (payload) => {
  console.log("payload for file data", payload);
  return axios.get(
    `${URLMAP.FILE}files?startDate=${payload.selectedDateRange.startDate}&endDate=${payload.selectedDateRange.endDate}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const postFileDetasils = async (payload) => {
  return axios.post(`${URLMAP.FILE}files`, payload.data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const updateScheduleCallTime = async (payload) => {
  return axios.patch(
    `${URLMAP.FILE}files/${payload.patchData._id}`,
    payload.patchData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const updateStopCall = async (payload) => {
  return axios.patch(
    `${URLMAP.FILE}files/callCancel/${payload.patchData._id}`,
    payload.patchData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const disableFile = async (payload) => {
  return axios.patch(
    `${URLMAP.FILE}files/disableFile/${payload.patchData._id}`,
    payload.patchData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const triggerFileProcessingAPI = async (payload) => {
  return axios.post(`${URLMAP.FILEPROCESS}fileprocess/`, payload.data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const downloadFileFromBlob = async (payload) => {
  console.log("Download file paylad===>", payload);
  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${payload.blobDetails.storageAccountName}.blob.core.windows.net/?${payload.blobDetails.sastoken}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(
    payload.blobDetails.containerName
  );
  const blockBlobClient = containerClient.getBlockBlobClient(
    payload.uploadedName
  );
  // let res = await blockBlobClient.download(payload.csvFile, payload.csvFile.size);
  return blockBlobClient;
};

export const stopCurrentCall = (payload) => {
  const fileId = payload.fileId;
  var data = JSON.stringify({
    batchId: fileId,
  });
  // return {
  //   status:200,
  //   data: {
  //     incomplete_calls: [6289700313, 8820785788, 8249468035, 9733608643],
  //     message: "Call stopping initiated",
  //   },
  // };
  return axios.post(URLMAP.STOPCALL, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic cWdfYWRtaW46cWdAb20xMjM=",
    },
  });
};

export const callStatusFromFileId = (payload) => {
  const fileId = payload.fileId;

  return axios.get(URLMAP.FILESTATUS + "?batchId=" + fileId, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic cWdfYWRtaW46cWdAb20xMjM=",
    },
  });
};

export const getGlobalConfigParamsData = async (payload) => {
  // return globalWorkflowConfig
  return axios.get(`${URLMAP.GLOBALCONFIG}config/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const updateGlobalConfigParamsData = async (payload) => {
  console.log("update payload data to api--->");
  return axios.post(`${URLMAP.GLOBALCONFIG}config`, payload.data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const downloadAudioFileFromBlob = (fileUrl) => {
  if (fileUrl) {
    // let filePath = fileUrl.split(BLOBSTORAGEURL + BLOBCONTAINER + "/")[1];
    console.log("Download file paylad===>", fileUrl);
    // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
    // const blobService = new BlobServiceClient(`${BLOBSTORAGEURL}?${SASTOKEN}`);
    // get Container - full public read access
    // const containerClient = blobService.getContainerClient(BLOBCONTAINER);
    // const blockBlobClient = containerClient.getBlockBlobClient(filePath);
    console.log("fileUrl to download", fileUrl + "?" + SASTOKEN);
    return fileUrl + "?" + SASTOKEN;
    // let blobs = [];
    // const prefix = "104_11262741_9182685607_14";
    // for await (const blob of containerClient.listBlobsFlat({ prefix })) {
    //   blobs.push(blob.name);
    // }

    // console.log("Found blobs:", blobs);
  } else {
    return null;
  }

  // let res = await blockBlobClient.download(payload.csvFile, payload.csvFile.size);
};

export const exportDashboardApiData = (payload) => {
  return axios.get(
    `${URLMAP.ANALYTICS}analytics/table/requtDashboardExport?startDate=${payload.selectedDateRange.startDate}&endDate=${payload.selectedDateRange.endDate}&scenarioID=${payload.scenarioID}&queryType=${payload.queryType}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const exportReinitiateCallList = (payload) => {
  return axios.get(
    `${URLMAP.ANALYTICS}analytics/table/checkUnanswered/${payload.batchId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

export const processWAVfilreApi = async (payload) => {
  return axios.post(`http://localhost:3050/convert-to-mp3`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
  });
};

export const triggerAnalyticsRefreshApi = (payload) => {
  console.log("Trigger refresh payload", payload);
  return axios.post(
    `${URLMAP.ANALYTICS}analytics/triggerRefresh/`,
    {
      sessionId: payload.sessionId,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const makeCallResolvedApi = (payload) => {
  console.log("Make resolved payload", payload);
  return axios.post(
    `${URLMAP.ANALYTICS}analytics/makeIssueResolved/`,
    {
      sessionId: payload.sessionId,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
